<template lang="html">
    <div class="small-6 cell image-cells">
        <a :href="dataSourceFull" data-lightbox="image-1">
            <div class="img-container" :style="{ 'background': 'url(' + dataSource + ')'}"></div>
        </a>
        <span class="remove-image" aria-hidden="true" :data-open="'removeImageModal' + upload.id">&times;</span>

        <div class="reveal" :id="'removeImageModal' + upload.id" data-reveal>
            <div class="modal-header">
                <h3><b>Er du sikker?</b></h3>
            </div>
            <div class="modal-body">
                <p>Du er ved at slette et billede</p>
                <div>
                    <img :src="dataSource" class="img-center" alt="">
                    <div class="spacing"></div>
                    <div class="grid-x">
                        <div class="small-6 cell" style="padding-right: 4px;">
                            <button class="button" :data-close="'removeImageModal' + upload.id">Annuller</button>
                        </div>
                        <div class="small-6 cell" style="padding-left: 4px;">
                            <button class="button call-to-action" :data-close="'removeImageModal' + upload.id" v-on:click="removeUpload(upload.id)">Slet</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="js">
import DAL, {mongoObjectId} from './../js/Sync/dal';
import clearQueue from './../js/Sync/clearQueue';
import placeholder from './../assets/image/image.png';

export default {
    name: 'formUpload',
    props: ['upload'],
    data() {
        return {
            dataSource: undefined,
            dataSourceFull: undefined,
            images: []
        }
    },
    mounted() {
        var _this = this;
        $(document).foundation();

        if (_this.upload.thumb != null && _this.upload.thumb != undefined) {
            var result = _this.upload;
            var dataView = new DataView(result.thumb || result.data);
            var blob = new Blob([dataView], { type: result.type });

            _this.dataSource = URL.createObjectURL(blob);

            var dataViewFull = new DataView(result.data);
            var blobFull = new Blob([dataViewFull], { type: result.type });

            _this.dataSourceFull = URL.createObjectURL(blobFull);

        } else {
            _this.dataSource = placeholder; // <-- Placeholder
        }
    },
    methods: {
        removeUpload(id) {
            var _this = this;

            URL.revokeObjectURL(_this.dataSource);
            
            console.log("removeUpload", id);
        
            _this.$emit('removeUpload', id);
        }
    },
    beforeDestroy () {
        var _this = this;

        URL.revokeObjectURL(_this.dataSource);
        URL.revokeObjectURL(_this.dataSourceFull);
    }
}
</script>



// WEBPACK FOOTER //
// FormUpload.vue?75079384